var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgApiInterface = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8855 2.19866L37.8056 0.121911C37.73 0.0508881 37.6302 0.0113525 37.5264 0.0113525C37.4227 0.0113525 37.3228 0.0508881 37.2472 0.121911L33.5141 3.85189C31.893 2.75354 29.9792 2.16771 28.0211 2.17042C25.5114 2.17042 23.0018 3.12409 21.085 5.04085L16.0908 10.0351C16.0543 10.0715 16.0253 10.1148 16.0055 10.1624C15.9858 10.2101 15.9756 10.2611 15.9756 10.3127C15.9756 10.3643 15.9858 10.4154 16.0055 10.463C16.0253 10.5106 16.0543 10.5539 16.0908 10.5903L29.4077 23.9072C29.4446 23.9442 29.4887 23.9733 29.5373 23.9927C29.5858 24.0121 29.6378 24.0214 29.69 24.0202C29.7929 24.0181 29.8913 23.9779 29.9661 23.9072L34.9603 18.913C36.5694 17.3022 37.5682 15.1819 37.7857 12.9155C38.0031 10.6491 37.4257 8.37762 36.1524 6.49018L39.8855 2.75705C39.9587 2.68255 39.9997 2.58229 39.9997 2.47786C39.9997 2.37342 39.9587 2.27316 39.8855 2.19866Z",
    fill: "url(#paint0_linear_3451_61096)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2715 21.7018C23.1981 21.6291 23.0989 21.5882 22.9955 21.5882C22.8921 21.5882 22.7928 21.6291 22.7194 21.7018L19.4569 24.9644L15.0273 20.5411L18.3024 17.2723C18.3389 17.2359 18.3679 17.1926 18.3877 17.145C18.4074 17.0973 18.4176 17.0462 18.4176 16.9947C18.4176 16.9431 18.4074 16.892 18.3877 16.8444C18.3679 16.7967 18.3389 16.7535 18.3024 16.717L16.5205 14.932C16.4841 14.8955 16.4409 14.8665 16.3932 14.8468C16.3456 14.827 16.2945 14.8168 16.2429 14.8168C16.1913 14.8168 16.1403 14.827 16.0926 14.8468C16.045 14.8665 16.0017 14.8955 15.9653 14.932L12.6933 18.204L10.5852 16.0959C10.5482 16.0589 10.5042 16.0299 10.4556 16.0104C10.4071 15.991 10.3551 15.9817 10.3029 15.983C10.2 15.985 10.1016 16.0253 10.0268 16.0959L5.03885 21.0901C3.4298 22.701 2.43097 24.8212 2.21349 27.0876C1.99601 29.354 2.5734 31.6255 3.84676 33.5129L0.113641 37.2461C0.0408435 37.3195 0 37.4187 0 37.5221C0 37.6255 0.0408435 37.7248 0.113641 37.7982L2.19352 39.8781C2.26914 39.9491 2.36898 39.9886 2.47272 39.9886C2.57646 39.9886 2.6763 39.9491 2.75192 39.8781L6.48504 36.145C8.13515 37.2712 10.055 37.8296 11.9749 37.8296C14.4846 37.8296 16.9942 36.8728 18.9141 34.956L23.9084 29.9618C23.9449 29.9253 23.9739 29.8821 23.9936 29.8344C24.0134 29.7868 24.0236 29.7357 24.0236 29.6841C24.0236 29.6326 24.0134 29.5815 23.9936 29.5339C23.9739 29.4862 23.9449 29.4429 23.9084 29.4065L21.8002 27.3015L25.0691 24.0296C25.1419 23.9561 25.1827 23.8569 25.1827 23.7535C25.1827 23.6501 25.1419 23.5509 25.0691 23.4774L23.2747 21.7018H23.2715Z",
    fill: "url(#paint1_linear_3451_61096)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3451_61096",
    x1: 27.9876,
    y1: 0.0113525,
    x2: 27.9876,
    y2: 24.0203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#189EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3863D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3451_61096",
    x1: 12.5914,
    y1: 14.8168,
    x2: 12.5914,
    y2: 39.9886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7F741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECA25"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgApiInterface);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/api-interface.ac244c6537b201e16ec41002fc1b98e6.svg";